export const local_storage_ulsemo_user_fingerprint = "ulsemo_user_fingerprint"
export const CLIENT_STORE = "Client"
export const STYLES_STORE = "Styles"
export const MIN_VISITOR_DURATION = 8000 // 8s
